module.exports = __webpack_public_path__ + "static/media/yves-lg.47414bef.jpg";